<template>
  <div>
    <s-header>
      <div class="mt-3 -mb-3">Waste</div>
    </s-header>

    <section class="flex flex-row justify-start">
      <s-button
        left-icon="file-plus"
        class="mt-6 mb-6 mr-6 shadow-lg z-0"
        @click="$modal.show('modal--waste')"
      >
        Create Waste Log
      </s-button>
    </section>

    <section
      v-if="!isWaste"
      class="mt-6 sm:mt-8 px-6 py-2 text-lg sm:text-2xl font-semibold text-gray-800 text-left leading-tight border-l-4 border-gray-800"
    >
      No waste entries.
    </section>

    <section class="mt-6">
      <waste
        v-for="(waste, index) in pendingWaste"
        :pending="true"
        :ref="`waste-${waste}`"
        :key="waste"
        :waste-id="waste"
        :index="index"
        :active-item="activeChild"
        @focused="setFocus($event)"
        class="mt-4"
      />
      <waste
        v-for="(waste, index) in completedWaste"
        :closed="true"
        :ref="`waste-${waste}`"
        :key="waste"
        :waste-id="waste"
        :index="index + pendingWaste.length"
        :active-item="activeChild"
        @focused="setFocus($event)"
        class="mt-4"
      />
    </section>
  </div>
</template>

<script>
import SHeader from '@/components/SHeader'
import SButton from '@/components/Button'
import Waste from '@/components/Waste'
import { mapGetters } from 'vuex'

export default {
  name: 'WasteList',
  data() {
    return {
      activeChild: -1
    }
  },
  components: {
    SHeader,
    SButton,
    Waste
  },
  computed: {
    ...mapGetters('storeModule/waste', [
      'waste',
      'pendingWaste',
      'completedWaste',
      'wasteOrdered',
      'isWaste'
    ])
  },
  methods: {
    setFocus(i) {
      this.activeChild = i
    }
  }
}
</script>
